import React, {Component} from 'react';
import {Dialog} from 'primereact/dialog';
import {ProgressSpinner} from 'primereact/progressspinner';

export class ComponentsAppSplash extends Component {

    //onHide={(e) => this.setState({splash: false})}

    render(){
        return (

            <Dialog 
                visible={this.props.visible} 
                modal={true}
                closable={false}
                showHeader={false}
                contentStyle={{overflow: 'hidden'}}
                onHide={()=>{}}
            >
                <div className="p-fluid">
                    <div className="p-grid">
                        <div className="p-col-12">
                        </div>
                        <div className="p-col-1">
                        </div>
                        <div className="p-col-3">
                            <ProgressSpinner/>
                        </div>
                    </div>
                </div>
            </Dialog>                  
        );

    }
}